<script>
  export let title;
  export let text;
</script>

<div class="container">
  <h1>{@html title}</h1>
  <p>{@html text}</p>
</div>


<style>
  .container {
    margin: 1% 7% 1% 7%;
    text-align: left;
  }

  h1 {
    font-size: 2rem;
    font-family: 'Oswald', sans-serif;
    padding: 1rem 0 1rem 0;
    font-style: italic;
  }
  p {
    font-size: 1rem;
    font-family: 'Arial';
    line-height: 1.5;
  }
</style>